import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../Environment/environment';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(private http: HttpClient) { }
  
  // ---------------------- Login API ---------------------- //

  postLoginApi(params: any, api: string) {
    const url = `${environment.baseUrl}${api}`
    return this.http.post(url, params)
  }

}
